import { render, staticRenderFns } from "./HistoryDetailDefaultLayout.vue?vue&type=template&id=4e984faf&scoped=true"
import script from "./HistoryDetailDefaultLayout.vue?vue&type=script&lang=js"
export * from "./HistoryDetailDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e984faf",
  null
  
)

export default component.exports